@import "../../conversational-search-partials/button/button.scss";

.conversational-search-suggestion-buttons {
  display: flex;
  flex-wrap: wrap;

  &__button {
    display: grid;
    margin-right: 16px;
    margin-top: 16px;
  }
}
